import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';
import { StpOrganizationAddressUpdateRequest } from '../../DTO/stp-organization-address-update-request.model';

@Component({
  selector: 'stp-organization-representative.component',
  templateUrl: './stp-organization-representative.component.html',
  styleUrls: ['./stp-organization-representative.component.scss'],
})
export class StpOrganizationRepresentativeComponent implements OnInit {
  basicProfileForm!: FormGroup;
  stpMainId: number;
  organizationDetails: any;
  stpOrganizationAddressUpdateRequest: StpOrganizationAddressUpdateRequest = new StpOrganizationAddressUpdateRequest();

  constructor(
    private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private notification: NzNotificationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.stpMainId = this.route.snapshot.params.id;
    this.checkStpMain();
    this.getStpOrganizationalDetailsById();
  }

  private checkStpMain(){
    if(!this.stpMainId || this.stpMainId == 0){
      this.notification.error('Error', 'Please fill up your basic profile first!');
        this.router.navigate(['/home/stp-registration/dash-board']);
    }else{
      this.basicProfileForm = this.fb.group({
        contactNumberPrefixForContactNo: ['+880'],
        contactNumberPrefixForContactNumber: ['+880'],
        organizationContactNo: [
          '',
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.minLength(10),
            Validators.pattern(/^[0-9]*$/),
          ],
        ],
        organizationEmail: ['', [Validators.email, Validators.required]],
        representativeName: ['', Validators.required],
        representativeDesignation: ['', Validators.required],
        representativeContactNo: [
          '',
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.minLength(10),
            Validators.pattern(/^[0-9]*$/),
          ],
        ],
        representativeEmail: ['', [Validators.email, Validators.required]],
      });
    }
  }


  getStpOrganizationalDetailsById() {
    this.stpRegistrationStorageService
      .getStpOrganizationDetails(this.stpMainId)
      .subscribe((res) => {
        this.organizationDetails = res.data;
        this.basicProfileForm.patchValue({
          organizationContactNo: res.data.organizationContactNo.substring(4),
          organizationEmail: res.data.organizationEmail,
          representativeName: res.data.representativeName,
          representativeDesignation: res.data.representativeDesignation,
          representativeContactNo: res.data.representativeContactNo.substring(4),
          representativeEmail: res.data.representativeEmail,
        });
      });
  }

  update() {
    this.stpOrganizationAddressUpdateRequest.stpMainId = this.stpMainId
    this.stpOrganizationAddressUpdateRequest.organizationContactNo = '+880' + this.basicProfileForm.value.organizationContactNo;
    this.stpOrganizationAddressUpdateRequest.organizationEmail = this.basicProfileForm.value.organizationEmail;
    this.stpOrganizationAddressUpdateRequest.representativeName = this.basicProfileForm.value.representativeName;
    this.stpOrganizationAddressUpdateRequest.representativeDesignation = this.basicProfileForm.value.representativeDesignation;
    this.stpOrganizationAddressUpdateRequest.representativeContactNo = '+880' + this.basicProfileForm.value.representativeContactNo;
    this.stpOrganizationAddressUpdateRequest.representativeEmail = this.basicProfileForm.value.representativeEmail;
    this.stpOrganizationAddressUpdateRequest.firstTime = this.organizationDetails.firstTime;
    this.stpRegistrationStorageService.updateStpOrganizationDetails(this.stpOrganizationAddressUpdateRequest).subscribe({
      next: (res) => {
        this.notification.success('Success', 'STP Contact Information Updated Successfully!');
        this.router.navigate(['/home/stp-registration/stp-application-view/'+ this.stpMainId]);
      },
      error: (error) => this.notification.error('Failed', error.message),
    });
  }


}
